<div class="naybrs-logo-container" [ngStyle]="{ 'width.px': width }" [routerLink]="['/']">
  @if (useInlineSvg) {
  <div class="naybrs-logo-image" [style.height.px]="logoHeight" [innerHTML]="inlineLogoMarkup" aria-label="Naybrs logo"
    role="img"></div>
  } @else {
  <img
    class="naybrs-logo-image"
    [src]="logoSrc"
    [width]="width"
    [height]="logoHeight"
    alt="Naybrs logo"
    decoding="sync"
    fetchpriority="high" />
  }
</div>
